import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { FONT_FAMILY, THEME_COLORS } from '../../themes';


interface CardV3Props {
    header: string;
    mainContent: JSX.Element;
    rightComponent?: JSX.Element;
    actionText?: string;
    bottomText?: string;
    bottomComponent?: () => JSX.Element;
    onAction?: () => any
}

export const CardV3 = ({ header, mainContent, rightComponent = null, actionText, bottomText, bottomComponent, onAction }: CardV3Props) => {
    return (
        <View style={styles.card}>
            <Text style={styles.headerText}>{header}</Text>
            <View style={{ flexDirection: 'row', alignItems: 'center', marginVertical: '1em' }}>
                {mainContent}
                {rightComponent}
            </View>
            {actionText && <TouchableOpacity style={styles.bottomContent} onPress={onAction}>
                <Text style={styles.actionableText}>{actionText}</Text>
            </TouchableOpacity>}

            {bottomText && <Text style={styles.bottomContent}>{bottomText}</Text>}
            {bottomComponent && <View style={styles.bottomContent}>{bottomComponent()}</View>}
        </View>      
    )
}

const styles = StyleSheet.create({
    card: {
        width: 'fit-content',
        minWidth: 225,
        minHeight: 120,
        backgroundColor: THEME_COLORS.sideMenuBg,
        borderRadius: 6,
        padding: 15,
        margin: '1em',
        position: 'relative'
    },
    headerText: {
        color: THEME_COLORS.sideMenuGrey,
        fontSize: 13,
        lineHeight: 24,
        fontFamily: FONT_FAMILY.primaryV3
    },
    bottomContent: {
        // paddingVertical: 16,
    },
    actionableText: {
        color: THEME_COLORS.purple,
        fontFamily: FONT_FAMILY.mediumV3
    }
})
